export default "__VITE_ASSET__CH9HnhVe__"